// SAT Module Routes
const satModule = '/sat-module';

export const routes = {
  base: satModule,

  // Main pages
  settings: `${satModule}/settings`,
  schoolStructure: `${satModule}/school-structure`,
  lunchStructure: `${satModule}/school-structure/lunch-structure`,

  // Curriculum Plan
  curriculumPlan: `${satModule}/curriculum-plan`,

  // Rules & Preferences
  rulesPreferences: `${satModule}/rules-preferences`,

  // Timetable Management
  timetable: `${satModule}/timetable/view`,
  createTimetable: `${satModule}/timetable/create`,
  createTimetableVersion: `${satModule}/timetable/version/create`,

  // User Management
  teachers: `${satModule}/user-management/teachers`,
  teacherDetail: (id: string) => `${satModule}/user-management/teachers/${id}`,

  // System routes
  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-module'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    relative = absolutePath.substring(baseName.length);
  }

  return relative.startsWith('/') ? relative.substring(1) : relative;
}

export default routes;
